var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companies-card"},[_c('img',{attrs:{"src":"/images/promo/connect-features/companies-card.svg","alt":"Companies card"}})])}]

export { render, staticRenderFns }